import SegmentList from "../SegmentList";
import { useNavigate } from "react-router-dom";
import BreadcrumbWrapper from "../BreadcrumbWrapper/index";
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import ShowFor from '@Components/ShowFor';

const Segments = () => {
  const navigate = useNavigate();
  return (
    <div>
      <BreadcrumbWrapper crumbArray={[{ path: "/segments", label: "Segments" }]} />
      <div className="p-4">
        <div className="mb-4 flex items-center justify-between">
          <h1 className="mb-4 text-2xl font-bold">Segments</h1>

          <ShowFor permissions={['SEGMENTS_WRITE']}>
            <Button
              onClick={() => navigate("/segments/new")}
            >
              Create segment
            </Button>
          </ShowFor>
        </div>

        <div className="pb-10">
          <SegmentList />
        </div>
      </div>
    </div>
  );
};

export default Segments;
